import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-240a6792"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-group-page" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold mb-1" }, "Criar Time", -1))
const _hoisted_4 = { class: "text-muted mb-0" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Nome do time", -1))
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tag", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "2 a 8 caracteres, exibida antes do nome.", -1))
const _hoisted_12 = { class: "mb-8" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "País", -1))
const _hoisted_14 = { class: "multiselect-single-label" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_18 = { class: "d-flex gap-3" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Criar time ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Cancelar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, " Você será o capitão e poderá convidar até " + _toDisplayString(_ctx.maxMembers - 1) + " membros. ", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
              type: "text",
              class: "form-control",
              maxlength: "60",
              placeholder: "Ex.: Os Invasores"
            }, null, 512), [
              [
                _vModelText,
                _ctx.form.name,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.tag) = $event)),
              type: "text",
              class: "form-control text-uppercase",
              maxlength: "8",
              placeholder: "Ex.: INV"
            }, null, 512), [
              [
                _vModelText,
                _ctx.form.tag,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.form.country,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.country) = $event)),
              options: _ctx.countryOptions,
              searchable: true,
              placeholder: "Selecione um país",
              "no-results-text": "Nenhum país encontrado",
              label: "label",
              "track-by": "search",
              "value-prop": "value"
            }, {
              singlelabel: _withCtx(({ value }) => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: value.flag,
                    class: "country-flag me-2",
                    alt: ""
                  }, null, 8, _hoisted_15),
                  _createTextVNode(" " + _toDisplayString(value.label), 1)
                ])
              ]),
              option: _withCtx(({ option }) => [
                _createElementVNode("img", {
                  src: option.flag,
                  class: "country-flag me-2",
                  alt: ""
                }, null, 8, _hoisted_16),
                _createTextVNode(" " + _toDisplayString(option.label), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-info",
              disabled: _ctx.saving || !_ctx.valid
            }, [
              (_ctx.saving)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                : _createCommentVNode("", true),
              _hoisted_21
            ], 8, _hoisted_19),
            _createVNode(_component_router_link, {
              to: "/groups/me",
              class: "btn btn-light"
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ], 32)
      ])
    ])
  ]))
}